import styled from "styled-components";

export const MissionStatCardStyled = styled.div`
  .card_title {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .card_subtitle {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    margin-bottom: 8px;
  }

  .card_value_row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 8px;
    margin-bottom: 12px;

    .card_label {
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      color: ${({ theme }) => theme.COLORS.GRAY_26};
    }

    .card_value {
      font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
      font-size: ${({ theme }) => theme.FONT.SIZE.S24};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
    }

    .card_unit {
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      color: ${({ theme }) => theme.COLORS.GRAY_26};
    }
  }
`;
